export const HomePageExplore = [
	{
		tag: "Free",
		courses: [
			{
				heading: "Learn HTML",
				description:
					"This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
				level: "Beginner",
				lessionNumber: 5,
			},
			{
				heading: "Learn CSS",
				description:
					"This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
				level: "Beginner",
				lessionNumber: 6,
			},
			{
				heading: "Responsive Web design",
				description:
					"This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
				level: "Beginner",
				lessionNumber: 8,
			},
		],
	},
	{
		tag: "New to coding",
		courses: [
			{
				heading: "HTML",
				description:
					"This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
				level: "Beginner",
				lessionNumber: 5,
			},
			{
				heading: "C Language",
				description:
					"This course covers the basic concepts of C, including variables, data types, control flow, functions, pointers, arrays, memory, and compilation.",
				level: "Beginner",
				lessionNumber: 7,
			},
			{
				heading: "Python",
				description:
					"This course covers the basic concepts of Python, including variables, data types, control flow, functions, lists, dictionaries, modules, and scripting.",
				level: "Beginner",
				lessionNumber: 10,
			},
		],
	},
	{
		tag: "Most popular",
		courses: [
			{
				heading: "Java",
				description:
					"This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
				level: "Beginner",
				lessionNumber: 6,
			},
			{
				heading: "Python",
				description:
					"This course covers the basic concepts of Python, including variables, data types, control flow, functions, lists, dictionaries, modules, and scripting.",
				level: "Beginner",
				lessionNumber: 10,
			},
			{
				heading: "MERN",
				description:
					"This course introduces full-stack web development using MongoDB, Express, React, and Node.js, covering the fundamentals of building dynamic applications.",
				level: "Intermediate",
				lessionNumber: 20,
			},
		],
	},
	{
		tag: "Skills paths",
		courses: [
			{
				heading: "Flask",
				description:
					"This course introduces web development with Flask, covering routing, templates, request handling, databases, and creating simple dynamic applications.",
				level: "Advance",
				lessionNumber: 25,
			},
			{
				heading: "Django",
				description:
					"This course introduces web development with Django, covering models, views, templates, URL routing, authentication, and building dynamic applications.",
				level: "Advance",
				lessionNumber: 6,
			},
			{
				heading: "FastAPI",
				description:
					"This course introduces web development with FastAPI, covering routing, request handling, dependency injection, data validation, and building APIs efficiently.",
				level: "Beginner",
				lessionNumber: 6,
			},
		],
	},
	{
		tag: "Career paths",
		courses: [
			{
				heading: "Next.js",
				description:
					"This course introduces web development with Next.js, covering pages, routing, server-side rendering, API routes, dynamic content, and building modern apps.",
				level: "Intermediate",
				lessionNumber: 10,
			},
			{
				heading: "Angular",
				description:
					"This course introduces web development with Angular, covering components, templates, data binding, services, routing, and building dynamic single-page apps.",
				level: "Beginner",
				lessionNumber: 8,
			},
			{
				heading: "Operating System",
				description:
					"This course introduces operating systems, covering processes, memory management, file systems, scheduling, concurrency, and the fundamentals of system design.",
				level: "Beginner",
				lessionNumber: 6,
			},
		],
	},
];
